module.exports = __webpack_public_path__ + "static/media/progressBarSilver.1850e5c4.svg";